import { render } from "./maps-home-work.svg?vue&type=template&id=56e3e0ff?inline"
const script = {}
script.render = render

export default script